import { IVisitorQuestionnaireState } from './types';
import { IQuestionnaire } from '../../types';
import produce from 'immer';

const mergeQuestionnaireIntoState = (
  state: IVisitorQuestionnaireState,
  questionnaire: IQuestionnaire | null | undefined,
  showSections: boolean = true,
): IVisitorQuestionnaireState => {
  if (!questionnaire) return state;

  const newState = produce(state, (draftState) => {
    questionnaire.sections.forEach((section) => {
      draftState.sections.byId[section.id] = {
        id: section.id,
        heading: section.heading,
        questions: section.questions.map((question) => question.id),
      };

      if (showSections) {
        draftState.sections.allIds.push(section.id);
      } else {
        draftState.sections.allIds = draftState.sections.allIds.filter(
          (id) => id !== section.id,
        );
      }

      section.questions.forEach((question) => {
        draftState.questions.byId[question.id] = {
          id: question.id,
          text: question.text,
          yesMessage: question.yesMessage,
          noMessage: question.noMessage,
          answer: '',
          emailWhen: question.emailWhen,
        };

        draftState.questions.allIds.push(question.id);
      });
    });

    draftState.sections.allIds = Array.from(
      new Set(draftState.sections.allIds),
    );
    draftState.questions.allIds = Array.from(
      new Set(draftState.questions.allIds),
    );
  });

  return newState;
};

export default mergeQuestionnaireIntoState;
